import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter } from 'lodash';

import { GoalsTypes } from '../actions/goals.actions';

const initialState = {
  status: [],
  mtdytdClientRRGoals: {},
};

const createClientGoalForBonusRequest = (state, action) => {
  const { payload } = action;

  const status = cloneDeep(state.status);
  status.push(`pending-client-goalforbonus-${payload.clientId}`);

  return { ...state, status };
};
const createClientGoalForBonusSuccess = (state, action) => {
  const clientGoal = action.response.goal;

  const mtdytdClientRRGoals = cloneDeep(state.mtdytdClientRRGoals);

  const duration = clientGoal.duration.toLowerCase();
  if (mtdytdClientRRGoals[duration]) {
    const mtdytdClientRRGoalsByDuration = mtdytdClientRRGoals[duration];
    const branches = Object.keys(mtdytdClientRRGoalsByDuration);
    branches.forEach((branch) => {
      mtdytdClientRRGoals[duration][branch].goal = clientGoal;
    });
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-client-goalforbonus-${clientGoal.clientId}`, a));

  return { ...state, mtdytdClientRRGoals, status };
};
const createClientGoalForBonusFailure = (state, action) => {
  const { clientId } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-client-goalforbonus-${clientId}`, a));

  return { ...state, status };
};

const updateClientGoalForBonusRequest = (state, action) => {
  const { payload } = action;

  const status = cloneDeep(state.status);
  status.push(`pending-client-goalforbonus-${payload.clientId}`);

  return { ...state, status };
};
const updateClientGoalForBonusSuccess = (state, action) => {
  const clientGoal = action.response.goal;

  const mtdytdClientRRGoals = cloneDeep(state.mtdytdClientRRGoals);

  const duration = clientGoal.duration.toLowerCase();
  if (mtdytdClientRRGoals[duration]) {
    if (mtdytdClientRRGoals[duration]) {
      const mtdytdClientRRGoalsByDuration = mtdytdClientRRGoals[duration];
      const branches = Object.keys(mtdytdClientRRGoalsByDuration);
      branches.forEach((branch) => {
        mtdytdClientRRGoals[duration][branch].goal = clientGoal;
      });
    }
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-client-goalforbonus-${clientGoal.clientId}`, a));

  return { ...state, mtdytdClientRRGoals, status };
};
const updateClientGoalForBonusFailure = (state, action) => {
  const { clientId } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-client-goalforbonus-${clientId}`, a));

  return { ...state, status };
};

const getMTDYTDClientRRGoalsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-mtdytd-client-RRGoals');

  return { ...state, status };
};
const getMTDYTDClientRRGoalsSuccess = (state, action) => {
  const mtdytdClientRRGoals = action.response ? action.response : {};
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtdytd-client-RRGoals', a));

  return { ...state, mtdytdClientRRGoals, status };
};
const getMTDYTDClientRRGoalsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtdytd-client-RRGoals', a));

  return { ...state, status };
};

const clearGoalsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [GoalsTypes.CREATE_CLIENT_GOAL_FOR_BONUS_REQUEST]: createClientGoalForBonusRequest,
  [GoalsTypes.CREATE_CLIENT_GOAL_FOR_BONUS_SUCCESS]: createClientGoalForBonusSuccess,
  [GoalsTypes.CREATE_CLIENT_GOAL_FOR_BONUS_FAILURE]: createClientGoalForBonusFailure,

  [GoalsTypes.UPDATE_CLIENT_GOAL_FOR_BONUS_REQUEST]: updateClientGoalForBonusRequest,
  [GoalsTypes.UPDATE_CLIENT_GOAL_FOR_BONUS_SUCCESS]: updateClientGoalForBonusSuccess,
  [GoalsTypes.UPDATE_CLIENT_GOAL_FOR_BONUS_FAILURE]: updateClientGoalForBonusFailure,

  [GoalsTypes.GET_MTDYTD_CLIENT_RR_GOALS_REQUEST]: getMTDYTDClientRRGoalsRequest,
  [GoalsTypes.GET_MTDYTD_CLIENT_RR_GOALS_SUCCESS]: getMTDYTDClientRRGoalsSuccess,
  [GoalsTypes.GET_MTDYTD_CLIENT_RR_GOALS_FAILURE]: getMTDYTDClientRRGoalsFailure,

  [GoalsTypes.CLEAR_GOALS_REQUEST]: clearGoalsRequest,
});
